var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drop',{staticClass:"drop border pb-2 pr-2 rounded mt-1 mb-1 border-dashed",class:_vm.over ? 'border-success bg-light-success' : 'border-med-light-gray',style:({
    visibility: _vm.alwaysShow || (_vm.draggingComponent && !_vm.notAllowedComponent) ? 'visible' : 'hidden'
  }),on:{"dragover":function($event){_vm.over = true},"dragleave":function($event){_vm.over = false},"drop":_vm.handleDrop}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }